module.exports = __webpack_public_path__ + "img/hopways.66b67928.jpeg";